import React from "react";

export default function KPIPanel() {
  return (
    <div className="section__inner">
      <div className="section-heading">
        <p className="section-heading__eyebrow">The Architect Behind ECM</p>
        <h2 className="section-heading__title">Elliott’s Cognitive Timeline</h2>
        <p className="section-heading__subtitle">
          How the Cognitive Capital frameworks, storyworlds and operating
          systems emerged over time.
        </p>
      </div>

      <div className="timeline">
        <div className="timeline__item">
          <div className="timeline__card">
            <p className="timeline__year">2019–2023</p>
            <h3 className="timeline__title">Early Cognitive Foundations</h3>
            <p className="timeline__body">
              The seeds of cognitive measurement, frameworks and architectural
              thinking form through natural pattern recognition, discipline and
              cross-field curiosity.
            </p>
          </div>
        </div>

        <div className="timeline__item">
          <div className="timeline__card">
            <p className="timeline__year">2024</p>
            <h3 className="timeline__title">Pre-Formation Insights</h3>
            <p className="timeline__body">
              The subconscious blueprint consolidates — CCE, CEE and TSA begin
              aligning into a unified intellectual system before full conscious
              awareness.
            </p>
          </div>
        </div>

        <div className="timeline__item">
          <div className="timeline__card">
            <p className="timeline__year">2025</p>
            <h3 className="timeline__title">CCE Formalises</h3>
            <p className="timeline__body">
              Cognitive Capital Engine is codified as a measurable asset class,
              providing the world&apos;s first structured language for cognitive
              work and IP as capital.
            </p>
          </div>
        </div>

        <div className="timeline__item">
          <div className="timeline__card">
            <p className="timeline__year">2025</p>
            <h3 className="timeline__title">CEE Is Designed</h3>
            <p className="timeline__body">
              Cognitive Equity Exchange emerges as a market architecture for
              trading cognitive equity, allowing founders to convert intellectual
              architecture into investable instruments.
            </p>
          </div>
        </div>

        <div className="timeline__item">
          <div className="timeline__card">
            <p className="timeline__year">2025</p>
            <h3 className="timeline__title">TSA &amp; ECM Studio Emerge</h3>
            <p className="timeline__body">
              Twinkle&apos;s Star Adventures is engineered as the flagship
              healing universe, while ECM Studio unifies the entire methodology
              into a single AI–Human hybrid founder architecture.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}